import React, { useMemo } from 'react'
import { Box, Button } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import { useToggleState } from 'shared/hooks'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { summaryMappingAtom } from './atoms'
import { pathResult, unMappedData } from './types'
import { NodeSearchParams, openNode } from '../../utility/TreeNavigation'
import { useCurrentSelectedEditableIds } from '../../../mastersManagement/summaries/utility'

function useTableColumns() {
  const { treeId, versionId } = useCurrentSelectedEditableIds()
  return useMemo(() => {
    return [
      {
        title: 'NodeType',
        width: 50,
        rowContent: ({ summary: { summaryLevel } }: unMappedData) =>
          summaryLevel,
      },
      {
        title: 'SearchResult',
        width: 50,
        rowContent: ({ pathResult }: unMappedData) => {
          return (
            <Box>
              {pathResult.map((pathResult) => (
                <PathResultComponent
                  key={pathResult.nodeType}
                  pathResult={pathResult}
                  tree_id={treeId!}
                  version={versionId!}
                />
              ))}
            </Box>
          )
        },
      },
    ]
  }, [treeId, versionId])
}

function PathResultComponent({
  tree_id,
  version,
  pathResult: { nodeType, nodeTitle, found },
}: {
  pathResult: pathResult
  tree_id: string
  version: string
}) {
  return (
    <Box key={nodeType}>
      {`${nodeType}: "${nodeTitle}"`}
      {found && (
        <Button
          onClick={() =>
            openNode({
              tree_id,
              version,
              id: found,
            } as NodeSearchParams)
          }
        >
          Go
        </Button>
      )}
    </Box>
  )
}

export function UnMapped() {
  const mappings = useAtomValue(summaryMappingAtom)
  const [showTable, toggleShowTable] = useToggleState(false)
  const columns = useTableColumns()

  if (!mappings?.unMapped.length) return null

  if (showTable) {
    return (
      <Table
        title={`Missing: ${mappings.unMapped.length}`}
        columns={columns}
        items={mappings.unMapped}
        toolBarItems={[
          <Button key="hideTable" onClick={() => toggleShowTable()}>
            Hide Table
          </Button>,
        ]}
      />
    )
  }

  return (
    <Box>
      <Box>
        <Button
          color="inherit"
          variant="outlined"
          onClick={() => toggleShowTable()}
        >
          <strong>Missing Mapping:</strong> {mappings.unMapped.length}
        </Button>
      </Box>
    </Box>
  )
}
